import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { IntInputField } from '../shared/IntInputField';
import { useTranslation } from 'react-i18next';
import { LineGestureModel } from '../../../shared/combat/gestures/LineGestureModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { CircleGestureModel } from '../../../shared/combat/gestures/CircleGestureModel';
import { GesturePatternPreview } from './GesturePatternPreview';
import { undoableCombatConfigurationDeleteGesturePattern } from '../../stores/undo/operation/CombatConfigurationSubmitChangesOp';
const DeleteButtonContainer = styled.div.withConfig({
  displayName: "GesturePatternEditor__DeleteButtonContainer",
  componentId: "sc-rrw3qq-0"
})(["display:flex;justify-content:flex-end;button{color:red;}"]);
export const PointEditor = observer(({
  point
}) => {
  return /*#__PURE__*/React.createElement("span", null, "(\xA0", /*#__PURE__*/React.createElement(IntInputField, {
    value: point.x,
    onChange: point.setX.bind(point)
  }), "\xA0|\xA0", /*#__PURE__*/React.createElement(IntInputField, {
    value: point.y,
    onChange: point.setY.bind(point)
  }), "\xA0)");
});
export const GestureEditor = observer(({
  gesturePattern,
  gesture,
  gestureIndex
}) => {
  const {
    t
  } = useTranslation();

  if (gesture instanceof LineGestureModel) {
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_line"), ":"), /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_line_from"), " ", /*#__PURE__*/React.createElement(PointEditor, {
      point: gesture.from
    }), "\xA0\u2014\xA0", t("editor.combat_configuration_gesture_line_to"), " ", /*#__PURE__*/React.createElement(PointEditor, {
      point: gesture.to
    }), "\xA0", /*#__PURE__*/React.createElement("button", {
      onClick: () => gesturePattern.removeGesture(gestureIndex)
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faMinusCircle
    }))));
  }

  if (gesture instanceof CircleGestureModel) {
    return /*#__PURE__*/React.createElement("tr", {
      key: gesture.$modelId
    }, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_circle"), ":"), /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_circle_center"), " ", /*#__PURE__*/React.createElement(PointEditor, {
      point: gesture.center
    }), ",\xA0", t("editor.combat_configuration_gesture_circle_radius"), " ", /*#__PURE__*/React.createElement(IntInputField, {
      value: gesture.radius,
      onChange: gesture.setRadius.bind(gesture)
    }), "\xA0 \xA0", /*#__PURE__*/React.createElement("button", {
      onClick: () => gesturePattern.removeGesture(gestureIndex)
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faMinusCircle
    }))));
  }

  throw new Error("Not implemented");
});
export const GesturePatternEditor = observer(({
  gesturePattern,
  isGlobalPattern
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_pattern_gesture_precision"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(IntInputField, {
    value: gesturePattern.precision,
    onChange: gesturePattern.setPrecision.bind(gesturePattern)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_pattern_miss_tolerance"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(IntInputField, {
    value: gesturePattern.missTolerance,
    onChange: gesturePattern.setMissTolerance.bind(gesturePattern)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_pattern_a11y_key_sequence"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    size: 10,
    value: gesturePattern.keySequence,
    onChange: ({
      target
    }) => {
      if (target.value.match("^[wWaAsSD]*$")) {
        gesturePattern.setKeySequence(target.value.toUpperCase());
      }
    }
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement(GesturePatternPreview, {
    gesturePattern: gesturePattern,
    width: 200
  }))), gesturePattern.gestures.map((gesture, index) => /*#__PURE__*/React.createElement(GestureEditor, {
    key: gesture.$modelId,
    gesturePattern: gesturePattern,
    gesture: gesture,
    gestureIndex: index
  })), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement("button", {
    onClick: gesturePattern.addLineGesture.bind(gesturePattern)
  }, t("editor.combat_configuration_gesture_pattern_add_line_gesture")), /*#__PURE__*/React.createElement("button", {
    onClick: gesturePattern.addCircleGesture.bind(gesturePattern)
  }, t("editor.combat_configuration_gesture_pattern_add_circle_gesture")))))), isGlobalPattern && /*#__PURE__*/React.createElement(DeleteButtonContainer, null, /*#__PURE__*/React.createElement("button", {
    onClick: () => undoableCombatConfigurationDeleteGesturePattern(gesturePattern)
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMinusCircle
  }), " ", t("editor.combat_configuration_gesture_pattern_delete"))));
});